<template>
  <HeaderViewDesktop v-if="windowWidth >= 1320" />
  <HeaderViewMobile v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderViewDesktop from './header-view-desktop';
import HeaderViewMobile from './header-view-mobile';

export default {
  components: { HeaderViewDesktop, HeaderViewMobile },
  computed: {
    ...mapGetters('layoutModule', ['windowWidth']),
  },
};
</script>